<template>
    <div class="container">
        <a-spin tip="Carregando..." :spinning="spinning">
            <a-config-provider :locale="currentLocale">
                <a-card>
                    <template #title>
                        <a-breadcrumb separator=">">
                            <a-breadcrumb-item>
                                <span>Tipos de Serviço</span>
                            </a-breadcrumb-item>
                            <a-breadcrumb-item>Listar</a-breadcrumb-item>
                        </a-breadcrumb>
                    </template>
                    <template #extra>
                        <a-button :icon="h(PlusOutlined)" @click="createUpdate()">Novo Registro</a-button>
                        <a-button :icon="h(FileDoneOutlined)" @click="modalOpen = true">Gerar relatório de CNAEs</a-button>
                    </template>
                    <br><br>

                    <a-table :columns="columns" :data-source="dataSource" bordered>
                        <template #bodyCell="{ column, record }">
                            <template v-if="column.dataIndex === 'acronym'">
                                {{ record.acronym }}
                            </template>
                            <template v-if="column.key === 'acao'">
                                <a-tooltip title="Alterar">
                                    <a-button type="primary" class="center-flex" shape="circle"
                                              @click="createUpdate(record)">
                                        <template #icon>
                                            <FormOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                                <a-tooltip title="Excluir">
                                    <a-button type="primary"
                                              class="center-flex"
                                              danger
                                              shape="circle"
                                              @click="destroy(record)"
                                    >
                                        <template #icon>
                                            <DeleteOutlined/>
                                        </template>
                                    </a-button>
                                </a-tooltip>
                            </template>
                        </template>
                    </a-table>
                </a-card>

                <a-modal v-model:open="modalOpen" :maskClosable="false" width="95%" style="height: 800px" title="Relatório de CNAEs" :footer="null">
                    <div style="width: 100%; max-height: 700px; overflow-y:auto">
                        <a-table
                            :columns="reportsTable"
                            :data-source="formatado"
                            :row-key="record => record.id"
                            :pagination="{ pageSize: 100}"
                            :scroll="{ x: 1300, y: 580 }"
                            :virtual="true"
                            :loading="spinning"
                            class="report-table"
                        >
                            <template #descricao="{ text }">
                                <span style="font-size: 13px">{{ text }}</span>
                            </template>

                            <template #zoneamento="{ record, column }">
                                <div style="display: flex; height: 50px">
                                    <a-tooltip v-if="record.zoneamentos[column.title] === 'allowed'" :title="column.title + ' - Permitido'" :mouseLeaveDelay="0">
                                        <td style="background-color: green;" class="t-cell-icon"></td>
                                    </a-tooltip>
                                    <a-tooltip v-else-if="record.zoneamentos[column.title] === 'permissible'" :title="column.title + ' - Permissível'" :mouseLeaveDelay="0">
                                        <td style="background-color: yellow" class="t-cell-icon"></td>
                                    </a-tooltip>
                                    <a-tooltip v-else-if="record.zoneamentos[column.title] === 'prohibited'" :title="column.title + ' - Proibido'" :mouseLeaveDelay="0">
                                        <td style="background-color: red" class="t-cell-icon"></td>
                                    </a-tooltip>
                                    <a-tooltip v-else :title="column.title + ' - Não cadastrado'" :mouseLeaveDelay="0">
                                        <td style="background-color: lightgrey" class="t-cell-icon"></td>
                                    </a-tooltip>
                                </div>
                            </template>
                        </a-table>
                    </div>
                </a-modal>
            </a-config-provider>
        </a-spin>
    </div>
</template>

<script setup>
import {ref, h, onMounted} from 'vue';
import {PlusOutlined, FileDoneOutlined, FormOutlined, DeleteOutlined} from '@ant-design/icons-vue';
import ptBR from 'ant-design-vue/es/locale/pt_BR';
import {notification} from 'ant-design-vue';
import { openNotification } from '../../../../utils/utilities';

const dataSource = ref();
const currentLocale = ref(ptBR);
const spinning = ref(false);
const modalOpen = ref(false);
const tiposDeServico = ref([])
const formatado = []

const route = '/api/viabilidade/types-service';

const columns = ref([
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: {
                compare: (a, b) => a.id - b.id,
            },
            width: 150,
        },
        {
            title: 'Sigla',
            dataIndex: 'acronym',
            key: 'acronym',
            width: 150,
            sorter: {
                compare: (a, b) => a.acronym - b.acronym,
            },
        },
        {
            title: 'Descrição',
            dataIndex: 'description',
            key: 'description',
            width: 150,
            sorter: {
                compare: (a, b) => a.name - b.name,
            },
        },
        {
            title: 'Ação',
            key: 'acao',
            width: 50,
        }
    ])
const reportsTable = [
    { title: 'Código', dataIndex: 'codigo', key: 'codigo', width: 80, slots: { customRender: 'codigo' } },
    { title: 'Descrição', dataIndex: 'descricao', key: 'descricao', slots: { customRender: 'descricao' } },
    { title: 'Tipo de serviço', dataIndex: 'tipoDeServico', key: 'tipoDeServico', width: 120, slots: { customRender: 'tipoDeServico' }, fixed: 'top' },
]

const createUpdate = (data) => {
    (data) ? window.location.href = `/viabilidade/types-service/${data.id}/edit` : window.location.href = `/viabilidade/types-service/create` ;
}

onMounted(async () => {
    try {
        spinning.value = true
        const response = await window.axios.get(route);
        dataSource.value = response.data.data;

        const zonas = (await window.axios.get('/api/viabilidade/zoneamentos')).data.data.map((item) => item.description)
        zonas.forEach(zona => {
            reportsTable.push({
                    title: zona,
                    dataIndex: `zoneamentos['${zona}']`,
                    key: `zoneamentos['${zona}']`,
                    width: 60,
                    slots: { customRender: 'zoneamento' }
            })
        })

        let subclasses = (await window.axios.get('/proxy/ibge/cnae/subclasses'))
            .data
            .map(subclasse => ({ 'codigo': subclasse.id, 'descricao': subclasse.descricao }))
            .sort((a, b) => a.codigo.localeCompare(b.codigo))

        tiposDeServico.value = (await window.axios.get('/api/viabilidade/types-service/report')).data.data

        const cnaes = []
        for (const tipo of tiposDeServico.value) {
            tipo.cnaes.forEach(cnae => {
                cnaes.push([cnae, tipo.acronym, tipo.zoneamentos])
            })
        }

        subclasses.forEach(subclasse => {
            let encontrado = false

            cnaes.forEach(cnae => {
                if (cnae[0] === subclasse.codigo) {
                    formatado.push({
                        'codigo': subclasse.codigo,
                        'descricao': subclasse.descricao,
                        'tipoDeServico': cnae[1],
                        'zoneamentos': cnae[2]
                    })

                    encontrado = true
                }
            })

            if (!encontrado) {
                formatado.push({
                    'codigo': subclasse.codigo,
                    'descricao': subclasse.descricao,
                    'tipoDeServico': ' - ',
                    'zoneamentos': {}
                })
            }
        })

        spinning.value = false;
    } catch (error) {
        spinning.value = false;
    }
})

const destroy = async (data) => {
    try {
        const response = await window.axios.delete(route + `/${data.id}`);
        openNotification('success', response.data.message)
        window.location.reload();
    } catch (error) {
        openNotification('error', error.message)
    }
}
</script>

<style scoped>
.center-flex {
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

.anticon {
    vertical-align: 2px !important;
}

.t-cell-icon {
    border: none;
    width: 100%;
    height: 100%;
    padding-top: 0;
    text-align: center;
    vertical-align: middle;
}

.report-table >>> .ant-table-thead > tr > th,
.report-table >>> .ant-table-tbody > tr > td {
    padding: 0 !important;
    height: 40px !important;
    border: solid 1px black !important;
    text-align: center;
    vertical-align: middle;
    font-weight: bold;
}

.report-table >>> .ant-table-tbody > tr:nth-child(odd) > td {
    background-color: #fafafa;
}

.report-table >>> .ant-table-tbody > tr:hover > td {
    background-color: #e6f7ff !important;
}
</style>